module.exports = __webpack_public_path__ + "img/menu_bottom_4.acd79eb6.svg";